import { useState } from "react";
import { Eye, EyeOff, Check, X } from "lucide-react";
import { passwordRules, passwordStrength } from "@/lib/validators";

export function PasswordField({ value, onChange, placeholder, testId, autoComplete = "off" }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input type={show ? "text" : "password"} value={value} onChange={onChange}
        placeholder={placeholder} data-testid={testId} autoComplete={autoComplete}
        className="w-full rounded-lg border border-white/12 bg-surface px-3.5 py-2.5 pr-10 text-sm text-ink focus:border-azure focus:outline-none focus:ring-2 focus:ring-azure/40 transition-colors duration-200" />
      <button type="button" onClick={() => setShow(!show)} data-testid={testId ? `${testId}-toggle` : undefined}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-faint hover:text-ink transition-colors duration-200">
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
}

const RULES = [
  ["length", "At least 12 characters"],
  ["uppercase", "One uppercase letter"],
  ["lowercase", "One lowercase letter"],
  ["number", "One number"],
  ["special", "One symbol (e.g. ! @ # $)"],
];

export function PasswordChecklist({ value }) {
  const r = passwordRules(value);
  const score = passwordStrength(value);
  const labels = ["Very weak", "Weak", "Fair", "Good", "Strong", "Excellent"];
  const colors = ["bg-signal", "bg-signal", "bg-amber", "bg-amber", "bg-emerald", "bg-emerald"];
  return (
    <div className="mt-2" data-testid="password-checklist">
      <div className="flex items-center gap-2 mb-2">
        <div className="h-1.5 flex-1 rounded-full bg-white/10 overflow-hidden">
          <div className={`h-full ${colors[score]} transition-[width] duration-300`} style={{ width: `${(score / 5) * 100}%` }} />
        </div>
        <span className="text-[11px] font-mono text-faint w-16 text-right" data-testid="password-strength">{value ? labels[score] : ""}</span>
      </div>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1">
        {RULES.map(([k, label]) => (
          <li key={k} className={`flex items-center gap-1.5 text-[11px] ${r[k] ? "text-emerald" : "text-faint"}`} data-testid={`pwrule-${k}`}>
            {r[k] ? <Check size={12} /> : <X size={12} />} {label}
          </li>
        ))}
      </ul>
    </div>
  );
}
